"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TryExtensionLinkDialog = void 0;

var clsx_1 = __importDefault(require("clsx"));

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var globe_icon_svg_1 = __importDefault(require("./icons/globe-icon-svg"));

var link_icon_svg_1 = __importDefault(require("./icons/link-icon-svg"));

var lock_icon_svg_1 = __importDefault(require("./icons/lock-icon-svg"));

var QRLogo_1 = __importDefault(require("./icons/QRLogo"));

var QRCode_1 = require("./QRCode");

var Spinner_1 = require("./Spinner");

var TryExtensionLinkDialog_css_1 = __importDefault(require("./TryExtensionLinkDialog-css"));

var TryExtensionLinkDialog = function TryExtensionLinkDialog(props) {
  var _ref = (0, hooks_1.useState)(!props.isOpen),
      _ref2 = _slicedToArray(_ref, 2),
      isContainerHidden = _ref2[0],
      setContainerHidden = _ref2[1];

  var _ref3 = (0, hooks_1.useState)(!props.isOpen),
      _ref4 = _slicedToArray(_ref3, 2),
      isDialogHidden = _ref4[0],
      setDialogHidden = _ref4[1];

  (0, hooks_1.useEffect)(function () {
    var isOpen = props.isOpen;
    var timers = [window.setTimeout(function () {
      setDialogHidden(!isOpen);
    }, 10)];

    if (isOpen) {
      setContainerHidden(false);
    } else {
      timers.push(window.setTimeout(function () {
        setContainerHidden(true);
      }, 360));
    }

    return function () {
      timers.forEach(window.clearTimeout);
    };
  }, [props.isOpen]);
  return (0, preact_1.h)("div", {
    class: (0, clsx_1.default)("-walletlink-extension-dialog-container", isContainerHidden && "-walletlink-extension-dialog-container-hidden")
  }, (0, preact_1.h)("style", null, TryExtensionLinkDialog_css_1.default), (0, preact_1.h)("div", {
    class: (0, clsx_1.default)("-walletlink-extension-dialog-backdrop", isDialogHidden && "-walletlink-extension-dialog-backdrop-hidden")
  }), (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog"
  }, (0, preact_1.h)("div", {
    class: (0, clsx_1.default)("-walletlink-extension-dialog-box", isDialogHidden && "-walletlink-extension-dialog-box-hidden")
  }, (0, preact_1.h)(TryExtensionBox, {
    onInstallClick: function onInstallClick() {
      window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
    }
  }), !props.connectDisabled ? (0, preact_1.h)(ScanQRBox, {
    darkMode: props.darkMode,
    version: props.version,
    sessionId: props.sessionId,
    sessionSecret: props.sessionSecret,
    walletLinkUrl: props.walletLinkUrl,
    isConnected: props.isConnected,
    isParentConnection: props.isParentConnection
  }) : null, props.onCancel && (0, preact_1.h)(CancelButton, {
    onClick: props.onCancel
  }))));
};

exports.TryExtensionLinkDialog = TryExtensionLinkDialog;

var TryExtensionBox = function TryExtensionBox(props) {
  return (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-top"
  }, (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-top-install-region"
  }, (0, preact_1.h)("h2", null, "Try the Coinbase Wallet extension"), (0, preact_1.h)("button", {
    onClick: props.onInstallClick
  }, "Install")), (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-top-info-region"
  }, (0, preact_1.h)(DescriptionItem, {
    icon: link_icon_svg_1.default,
    text: "Connect to crypto apps with one click"
  }), (0, preact_1.h)(DescriptionItem, {
    icon: lock_icon_svg_1.default,
    text: "Your private key is stored securely"
  }), (0, preact_1.h)(DescriptionItem, {
    icon: globe_icon_svg_1.default,
    text: "Works with Ethereum, Polygon, and more"
  })));
};

var ScanQRBox = function ScanQRBox(props) {
  var serverUrl = window.encodeURIComponent(props.walletLinkUrl);
  var sessionIdKey = props.isParentConnection ? "parent-id" : "id";
  var qrUrl = "".concat(props.walletLinkUrl, "/#/link?").concat(sessionIdKey, "=").concat(props.sessionId, "&secret=").concat(props.sessionSecret, "&server=").concat(serverUrl, "&v=1");
  return (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-bottom"
  }, (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-bottom-description-region"
  }, (0, preact_1.h)("h2", null, "Or scan to connect"), (0, preact_1.h)("body", {
    class: "-walletlink-extension-dialog-box-bottom-description"
  }, "Open ", (0, preact_1.h)("a", {
    href: "https://wallet.coinbase.com/"
  }, "Coinbase Wallet"), " on your mobile phone and scan")), (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-bottom-qr-region"
  }, (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-bottom-qr-wrapper"
  }, (0, preact_1.h)(QRCode_1.QRCode, {
    content: qrUrl,
    width: 150,
    height: 150,
    fgColor: "#000",
    bgColor: "transparent",
    image: {
      svg: QRLogo_1.default,
      width: 34,
      height: 34
    }
  })), (0, preact_1.h)("input", {
    type: "hidden",
    value: qrUrl
  }), !props.isConnected && (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-bottom-qr-connecting"
  }, (0, preact_1.h)(Spinner_1.Spinner, {
    size: 36,
    color: "#000"
  }), (0, preact_1.h)("p", null, "Connecting..."))));
};

var DescriptionItem = function DescriptionItem(props) {
  return (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-top-description"
  }, (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-top-description-icon-wrapper"
  }, (0, preact_1.h)("img", {
    src: props.icon
  })), (0, preact_1.h)("body", {
    class: "-walletlink-extension-dialog-box-top-description-text"
  }, props.text));
};

var CancelButton = function CancelButton(props) {
  return (0, preact_1.h)("button", {
    class: "-walletlink-extension-dialog-box-cancel",
    onClick: props.onClick
  }, (0, preact_1.h)("div", {
    class: "-walletlink-extension-dialog-box-cancel-x"
  }));
};